import cctvCreator from './creator';

export default cctvCreator;
